/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from 'react'
import { useIntl } from 'react-intl'
import { PageTitle } from '../../../_metronic/layout/core'
import { NewsDashboard } from './components/NewsDashboard'
import { JobsDashboard } from './components/JobsDashboard'
import JobConfirmationsDashboard from './components/JobConfirmationsDashboard'
import CompanyConfirmationsDashboard from './components/CompanyConfirmationsDashboard'
import { useAuth } from '../../modules/auth'
import { GetRoleAsyncOutputItem } from '../../modules/base-definitions/components/roles/core/dto/getRoleAsyncOutput'
import { PermissionName } from '../../modules/auth/core/_permission'
import { FeaturedNewsDashboard } from './components/FeaturedNewsDashboard'
import './styles/dashboard.css'

interface DashboardPageProps {
  permissions?: GetRoleAsyncOutputItem[];
}
const DashboardPage: FC<DashboardPageProps> = ({permissions}) => (
  <>
    <div className='row g-5 gx-xxl-8'>
      {
        permissions?.some(x => x.name === PermissionName.GraduatedPanel) ?
          <>
            <div className='col-xxl-12'>
              {<FeaturedNewsDashboard />}
            </div>
            <div className='col-xxl-12'>
              {<NewsDashboard />}
            </div>
            <div className='col-xxl-12'>
              {<JobsDashboard />}
            </div> 
          </>: 
          <></>
      }
       {
        permissions?.some(x => x.name === PermissionName.CompanyMonitoring) ?
          <>
            <div className='col-md-6 col-lg-6 col-xl-6 col-xxl-3 mb-md-5 mb-xl-10'>
              <CompanyConfirmationsDashboard />
            </div>
            <div className='col-md-6 col-lg-6 col-xl-6 col-xxl-3 mb-md-5 mb-xl-10'>
              <JobConfirmationsDashboard />
            </div>
          </>
          :<></>
      }
    </div>
  </>
)

const DashboardWrapper: FC = () => {
  const intl = useIntl()
  const { currentUser } = useAuth();
  const permissions = currentUser?.result?.permissions;
  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({ id: 'MENU.DASHBOARD' })}</PageTitle>
      <DashboardPage permissions={permissions} />
    </>
  )
}

export { DashboardWrapper }
